import {FAILURE, PENDING, SUCCESS} from '../../constants'

const ACTION = 'GET_ITEMS'

export const GTS_FAILURE = `${ACTION}_${FAILURE}`
export const GTS_PENDING = `${ACTION}_${PENDING}`
export const GTS_SUCCESS = `${ACTION}_${SUCCESS}`
// export const ITEMS_SET = `ITEMS_SET`
